import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './Navbar';
import Home from './Home';
import Experience from './Experience';
import Education from './Education';
import Projects from './Projects';
import Contact from './Contact';
import Footer from './Footer';
import MSMBADetail from './EducationDetails/MSMBADetail';
import MSMMBADetail from './EducationDetails/MSMMBADetail';
import BSDetail from './EducationDetails/BSDetail';
import ASDetail from './EducationDetails/ASDetail';
import ScrollToTop from './ScrollToTop';


function App() {
  return (
    <Router>
      <ScrollToTop />
      <div>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/education" element={<Education />} />
          <Route path="/education/msmba" element={<MSMBADetail />} />
          <Route path="/education/msmmba" element={<MSMMBADetail />} />
          <Route path="/education/bs" element={<BSDetail />} />
          <Route path="/education/as" element={<ASDetail />} />
          <Route path="/experience" element={<Experience />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
